export function KeyIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <circle cx="5" cy="5" r="3" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="m7.5 7.5 6 6m-2-2 2-2m-4 0 2-2"
        stroke="currentColor"
        strokeWidth="1.4"
      />
    </svg>
  );
}
